<template>
  <div class="single-board-page">
    <ModalConfirm :showMe="showMe" @confirmed="modalResponse">
      <h1 slot="header">{{ markedDone ? 'Unmark as done?' : 'Mark as done?' }}</h1>
      <p slot="body"></p>
    </ModalConfirm>
    <button class="mark-done" @click="toggleDone">
      <span class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
          <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" />
        </svg>
      </span>
      <span class="text">{{ markedDone ? 'Unmark as done' : 'Mark as done' }}</span>
    </button>
    <BoardItem v-if="board" :board="board" />
    <FileUploader
      :board_id="id"
      :userId="user.uid"
      @newFileUploaded="tellBoardAboutUpload"
      v-if="showUploads"
    />
    <UploadedFiles
      :files="board.downloadFiles"
      @fileDeleted="tellBoardToDeleteFile"
      v-if="showUploads"
    />
    <Notes :notes="board.notes" :board="board" @saveNotes="saveBoardNotes" />
    <section class="board-lists">
      <Lists :board_id="id" />
    </section>
  </div>
</template>

<script>
import firebase from "firebase/app";
import db from "@/fb/init";
// eslint-disable-next-line
import firestore from "firebase/firestore";
// import db from "@/fb/init";

import { EventBus } from "@/eventbus";

import BoardItem from "@/components/BoardItem";
import Lists from "@/components/Lists";
import FileUploader from "@/components/FileUploader";
import UploadedFiles from "@/components/UploadedFiles";
import Notes from "@/components/Notes";

import ModalConfirm from "@/components/ModalConfirm";

export default {
  name: "BoardView",
  components: {
    BoardItem,
    Lists,
    FileUploader,
    UploadedFiles,
    Notes,
    ModalConfirm
  },
  props: ["user"],
  data() {
    return {
      id: this.$route.params.id,
      board: {},
      showUploads: true,
      showMe: false
    };
  },
  computed: {
    markedDone() {
      return this.board.done;
    }
  },
  methods: {
    tellBoardToDeleteFile(file) {
      db.collection("boards")
        .doc(this.id)
        .update({
          downloadFiles: firebase.firestore.FieldValue.arrayRemove(file)
        });
    },
    tellBoardAboutUpload(downloadFile) {
      db.collection("boards")
        .doc(this.id)
        .update({
          downloadFiles: firebase.firestore.FieldValue.arrayUnion(downloadFile)
        });
    },
    saveBoardNotes(notes) {
      db.collection("boards")
        .doc(this.id)
        .update({
          notes: notes
        });
    },
    toggleDone() {
      EventBus.$emit("clearFlash");
      this.showMe = true;
    },
    modalResponse(response) {
      if (response) {
        this.board.done ? this.unmarkAsDone() : this.markAsDone();
      }
      this.showMe = false;
    },
    markAsDone() {
      db.collection("boards")
        .doc(this.board.board_id)
        .update({ done: true });
    },
    unmarkAsDone() {
      db.collection("boards")
        .doc(this.board.board_id)
        .update({ done: false });
    }
  },
  mounted() {
    EventBus.$emit("clearFlash");

    db.collection("boards")
      .where("board_id", "==", this.id)
      .onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if (change.type === "added") {
            this.board = change.doc.data();
          }
          if (change.type === "modified") {
            this.board = change.doc.data();
          }
        });
      });
  }
};
</script>
